import { PakMenuKeys } from '../enums';
import { MenuConfig } from '../interfaces';

export const PackMenuConfig: MenuConfig<PakMenuKeys>[] = [
  {
    id: PakMenuKeys.CreateRevision,
    label: 'createARevision',
    icon: 'alc-icon-revision',
  },
  {
    id: PakMenuKeys.CreateCopy,
    label: 'createACopy',
    icon: 'alc-icon-select-copy-add',
  },
  {
    id: PakMenuKeys.CreateSisterPack,
    label: 'sisterPackFromThisPack',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.CreateLocalContract,
    label: 'localContractFromThisPack',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.RouteQuote,
    label: 'routeQuote',
    icon: 'pi pi-spin pi-spinner',
  },
  {
    id: PakMenuKeys.ViewRoutingHistory,
    label: 'viewRoutingHistory',
    icon: 'pi pi-spin pi-spinner',
  },
  {
    id: PakMenuKeys.RespondToRequest,
    label: 'respondToRequest',
    icon: 'pi pi-spin pi-spinner',
  },
  {
    id: PakMenuKeys.TakeOwnership,
    label: 'takeOwnership',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.TransferOwnership,
    label: 'transferOwnership',
    icon: 'pi pi-spin pi-spinner',
    visible: true,
  },
  {
    id: PakMenuKeys.MakeContract,
    label: 'makeContractMakeContractLabel',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.MakePrototype,
    label: 'makePrototypeMakePrototypeLabel',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.GenerateDocument,
    label: 'generateDocument',
    icon: 'alc-icon-document',
  },
  {
    id: PakMenuKeys.SendToIrisStaging,
    label: 'sendToIrisStaging',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.ArchivePack,
    label: 'archivePack',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.UnarchivePack,
    label: 'unarchivePack',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
  {
    id: PakMenuKeys.Properties,
    label: 'properties',
    icon: 'alc-icon-info',
  },
  {
    id: PakMenuKeys.AssignAccount,
    label: 'assignAccount',
    icon: 'alc-icon-single-user',
  },
  {
    id: PakMenuKeys.DeleteQuote,
    label: 'deleteQuote',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
    visible: true,
  },
  {
    id: PakMenuKeys.ClearInbox,
    label: 'clearInbox',
    icon: 'pi pi-spin pi-spinner',
    visible: true,
  },
  {
    id: PakMenuKeys.SaveToSalesforce,
    label: 'saveToSalesforce',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
];

export const PrototypeMenuConfig: MenuConfig<PakMenuKeys>[] = [
  {
    id: PakMenuKeys.GenerateDocument,
    label: 'generateDocument',
    icon: 'alc-icon-document',
  },
  {
    id: PakMenuKeys.Properties,
    label: 'properties',
    icon: 'alc-icon-info',
  },
  {
    id: PakMenuKeys.SendToIrisStaging,
    label: 'sendToIrisStaging',
    icon: 'alc-send-icon',
  },
  {
    id: PakMenuKeys.DeleteQuote,
    label: 'deleteQuote',
    icon: 'pi pi-spin pi-spinner',
    disabled: true,
  },
];

export const PackMenuOnAccountPageConfig: MenuConfig<PakMenuKeys>[] = [
  {
    id: PakMenuKeys.OpenQuote,
    label: 'openQuote',
    icon: 'alc-icon-open-in-new',
  },
  ...PackMenuConfig,
];

export const PrototypeMenuOnAccountPageConfig: MenuConfig<PakMenuKeys>[] = [
  {
    id: PakMenuKeys.OpenQuote,
    label: 'openQuote',
    icon: 'alc-icon-open-in-new',
  },
  ...PrototypeMenuConfig,
];
